<aside class="sidebar"
       [class.sidebar--active]="storeService.sidebar">
  <nav class="sidebar__nav">
    <ul class="sidebar__list">
      <ng-container *ngFor="let item of menu; let i = index">
        <li class="sidebar__item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
          <a class="sidebar__link" [routerLink]="item.path">
            <span class="sidebar__icon">
              <ng-container *ngComponentOutlet="item.icon"></ng-container>
            </span>
            <span>{{ item.title }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </nav>
</aside>
